import LoadingComponent, { LoadingBall } from "@ingka/loading";

export const Loading = ({ text }: { text: string }) => {
  return (
    <LoadingComponent text={text}>
      <LoadingBall color="emphasised" size="large" />
    </LoadingComponent>
  );
};
